import {isNil} from 'lodash';

export default function decimalWithIconComparator(valueA, valueB) {
  const parsedValueA =
    !isNil(valueA) && valueA.value ? JSON.parse(valueA.value) : undefined;
  const parsedValueB =
    !isNil(valueB) && valueB.value ? JSON.parse(valueB.value) : undefined;
  const ownValueA =
    parsedValueA && parsedValueA.value ? parsedValueA.value : undefined;
  const ownValueB =
    parsedValueB && parsedValueB.value ? parsedValueB.value : undefined;

  let result;
  if (ownValueA > ownValueB) {
    result = 1;
  } else if (ownValueA < ownValueB) {
    result = -1;
  } else {
    result = 0;
  }
  return result;
}
